import React, { useState, useEffect, useReducer } from "react";
import axios from 'axios';

export const api = axios.create();
api.defaults.headers.common['Content-Type'] = 'application/json';

function responseReducer(state, action){
	switch(action.type){
		case 'INIT':
			return { 
				isLoading: false,
				isError: false };
		case 'START':
			return { ...state,
				isLoading: true,
				isError: false };
		case 'SUCCCESS':
			return { ...state,
				isLoading: false,
				isError: false,
				data: action.data,
				status: action.status };
		case 'ERROR':
			return { ...state,
				isLoading: false,
				isError: true,
				errorStatus: action.errorStatus };
		default:
			throw new Error();
	}
}

export function useApi(){
	const [request, setRequest] = useState();

	const [state, dispatch] = useReducer(responseReducer, {
		isLoading: false,
		isError: false,
	})

	useEffect( () => {
		let didCancel = false;

		const requestFunction = async () => {

			dispatch({ type: 'START' });

			try{
				const response = await api(request);

				if(!didCancel){
					dispatch({ type: 'SUCCCESS', data: response.data, status: response.status }); }

			}catch(error){
				console.error(error);
				
				if(!didCancel){
					if(error.response){
						dispatch({ type: 'ERROR', errorStatus: error.response.status });
					}else{
						dispatch({ type: 'ERROR' });
					}
				}
			}
		}

		if(request){
			requestFunction(); 
		}else{
			dispatch({ type: 'INIT' });
		}

		return () => {
			didCancel = true; }
	}, [request]);

	return [state, setRequest];
}
